/**
 * Pagination utility helpers for tables using NPIDataGrid.
 * Centralizes default page size logic so that changing the default requires
 * only updating this file.
 */

export const DEFAULT_PAGE_SIZE = 5;
export const DEFAULT_PAGE_SIZE_OPTIONS: number[] = [5, 10, 25, 50, 100];

/**
 * Resolves an effective page size.
 * - If an explicit pageSize is provided (non-null/undefined) return it.
 * - Else use the first entry in provided options (if any and non-empty).
 * - Else fall back to the global DEFAULT_PAGE_SIZE_OPTIONS first entry.
 */
export function resolvePageSize(pageSize?: number | null, pageSizeOptions?: number[] | null): number {
    if (typeof pageSize === 'number' && pageSize > 0) return pageSize;
    const opts = pageSizeOptions && pageSizeOptions.length > 0 ? pageSizeOptions : DEFAULT_PAGE_SIZE_OPTIONS;
    return opts.includes(DEFAULT_PAGE_SIZE) ? DEFAULT_PAGE_SIZE : opts[0];
}
